import { BrowserRouter as Router, useLocation } from 'react-router-dom'
import { CssBaseline } from '@mui/material'
import { QueryClientProvider } from '@tanstack/react-query'

import MainLayout from './layouts/MainLayout'
import AppRoutes from './routes/AppRoutes'
import { queryClient } from './lib/react-query'
import { SnackbarProvider } from './providers/SnackbarProvider'
import BackendConnectionErrorPage from './pages/errors/BackendConnectionErrorPage'
import { useBackendHealth } from './hooks/useBackendHealth'
import ErrorBoundary from './components/common/ErrorBoundary'
import { ThemeProvider } from './contexts/ThemeContext'
import { AuthProvider } from './contexts/AuthContext'
import NetworkStatusBanner from './components/common/NetworkStatusBanner'

/**
 * =========================
 * APP CONTENT
 * =========================
 */
function AppContent() {
  
  const location = useLocation()
  const pathname = location.pathname.toLowerCase()

  const publicRoutes = [
    '/login',
    '/signup',
    '/activate-account',
    '/activate',
    '/reset-password',
    '/provisioning',
  ]

  const isPublicPage = publicRoutes.some((path) => pathname.startsWith(path))

  if (isPublicPage) {
    return <AppRoutes />
  }

  return (
    <MainLayout>
      <AppRoutes />
    </MainLayout>
  )
}

/**
 * =========================
 * APP ROOT
 * =========================
 */
export default function App() {
  const { isConnected, isChecking, retry } = useBackendHealth()

  // ✅ backend offline screen
  if (!isConnected && !isChecking) {
    return (
      <ThemeProvider>
        <CssBaseline />
        <BackendConnectionErrorPage
          isRetrying={isChecking}
          onRetry={retry}
        />
      </ThemeProvider>
    )
  }

  return (
    <ErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <ThemeProvider>
          <CssBaseline />
          <NetworkStatusBanner />

          <AuthProvider>
            <SnackbarProvider>
              <Router>
                <AppContent />
              </Router>
            </SnackbarProvider>
          </AuthProvider>

        </ThemeProvider>

        {/*<ReactQueryDevtools initialIsOpen={false} /> */}
      </QueryClientProvider>
    </ErrorBoundary>
  )
}